import React, { useState, useEffect, useRef, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InterstitialAds from './InterstitialAds';

import dayjs from 'dayjs';
import {
  getPlatformBanner,
  updateBannerfetchStatus,
  getBannerDataById,
  syncLocalDataWithReduxStore,
  addBannerReport,
  clearBannerReport,
  getExclutionList,
  syncExclutionListWithReduxStore,
  getBannerSetting,
  syncBannerSettingsWithReduxStore,
  clearContentBannerData,
  clearGlobalBannerData,
  content_data_get_done,
  content_data_get_pending,
  updateBannerCardIndex,
  cleanCurrentQueue,
  updateBannerShowStatus
} from '../../Store/actions';
import { bannerLocalConstant } from './utils';
import * as bannerUtils from './utils';
import { Countdown } from '../../components/banner/utils';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router';
import AppConfig from '../../config/config';
import queryString from 'query-string';
import packageJson from '../../../package.json';
import { setSessionStorage } from '../../common/common';

import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

const api_url = AppConfig.apiLoc;
const appVersion = packageJson.version;
const BANNER_DATA_FETCH_INTERVAL = 30; //banner data will fetch after 30 minutes
const BANNER_DATA_FETCH_PERIOD = 'minute'; //banner data will fetch per days, minute
const BANNER_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

/**
 * @param {string} name of the page
 * @return {jsx} banner
 */

const getLocalStorage = (key, defaultValue) => {
  let local_data = localStorage.getItem(
    `${prodMode ? '@ClirnetStore_prod' : '@ClirnetStore_dev'}_${key}`
  );
  if (local_data) {
    return local_data;
  } else {
    return defaultValue;
  }
};

const innitial_current_queue = {
  top_banner_data: [],
  side_top_banner_data: [],
  bottom_banner_data: [],
  side_bottom_banner_data: [],
  list_banner_data: [],
  video_banner_data: [],
  video_floating_banner_data: [],
  interstitial_banner_data: []
};

function BannerWorker({ page_name = '', page_id = '' }) {
  const dispatch = useDispatch();

  const { search } = useLocation();
  const location = useLocation();
  const { id: url_id } = queryString.parse(search);
  const [platform_name, set_platform_name] = useState(bannerUtils.getPlatForm());
  const [content_id, set_content_id] = useState(page_id ? page_id : url_id ? url_id : 0);
  const [type, set_type] = useState(page_name);

  let visibilityChange = typeof document.hidden
    ? 'visibilitychange'
    : typeof document.msHidden
    ? 'msvisibilitychange'
    : typeof document.webkitHidden
    ? 'webkitvisibilitychange'
    : 'visibilitychange';
  let isReporting = useRef(false);
  let banner_list_data = useSelector((state) => state.banner.banner_data);

  let banner_exclution_list = useSelector((state) => state.banner.banner_exclution_list);

  let banner_settings = useSelector((state) => state.banner.banner_settings);

  let banner_report_data = useSelector((state) => state.banner.banner_report_data);
  //current queue of all position
  let banner_fetch_status = useSelector((state) => state.banner.banner_fetch_status);
  const banner_fetch_status_ref = useRef(0);

  let temp_banner_report_data = [];

  let local_store_banner_data = {
    get_timestamp: '',
    last_fetch_timestamp: '',
    expire_timestamp: '',
    global_banner_data: {}
    // banner_view_report_data: []
  };

  useEffect(() => {
    set_content_id(url_id);
  }, [url_id]);

  useEffect(() => {
    if (banner_report_data && banner_report_data?.length == 20) {
      dispatch(
        addBannerReport(banner_report_data, (response) => {
          dispatch(clearBannerReport());
          sessionStorage.setItem('banner_report', []);
        })
      );
    } else {
      sessionStorage.setItem('banner_report', JSON.stringify(banner_report_data));
    }

    return () => {};
  }, [banner_report_data]);

  useEffect(() => {
    banner_list_data && typeof banner_list_data == 'object' && syncWithSessionStorage();
  }, [banner_list_data]);

  useEffect(() => {
    console.log('effect', banner_fetch_status);
    if (banner_fetch_status_ref.current != banner_fetch_status) {
      banner_fetch_status_ref.current = banner_fetch_status;
    }
  }, [banner_fetch_status]);

  useEffect(() => {
    // dispatch(updateBannerShowStatus());
    // setSessionStorage(bannerLocalConstant.PLAYED_CATEGORY, JSON.stringify(innitial_current_queue));
    // let global_session_store_data = sessionStorage.getItem(bannerLocalConstant.GLOBAL_BANNER_DATA);
    // let global_local_store_data = bannerUtils.getDataFromLocalStorage(
    //   bannerLocalConstant.GLOBAL_BANNER_DATA
    // );

    // if (global_session_store_data) {
    //   global_session_store_data = JSON.parse(global_session_store_data);
    //   checkDataValidity(
    //     global_session_store_data.last_fetch_timestamp,
    //     global_session_store_data.expire_timestamp,
    //     global_session_store_data
    //   );
    // } else if (global_local_store_data) {
    //   global_local_store_data = JSON.parse(global_local_store_data);
    //   checkDataValidity(
    //     global_local_store_data.last_fetch_timestamp,
    //     global_local_store_data.expire_timestamp,
    //     global_local_store_data
    //   );
    // } else {
    //   dispatch(
    //     getBannerSetting((response) => {
    //       dispatch(
    //         getPlatformBanner((_response) => {
    //           syncBannerData(_response);
    //         })
    //       );
    //     })
    //   );
    // }

    // if (content_id && content_id != 0) {
    //   dispatch(getExclutionList());
    //   dispatch(
    //     getBannerDataById(type, content_id, (res) => {
    //       let tempUpdatedStatus = 0;
    //       tempUpdatedStatus = banner_fetch_status_ref.current + 1;
    //       console.log('get by id', tempUpdatedStatus, banner_fetch_status_ref.current);
    //       setTimeout(() => {
    //         dispatch(updateBannerfetchStatus(tempUpdatedStatus));
    //         dispatch(content_data_get_done());
    //       }, 500);
    //     })
    //   );
    // }
    // setSessionStorage(bannerLocalConstant.BANNER_CARD_INDEX, -1);
    document.addEventListener(visibilityChange, sendReportData);
    ////////////////////////////
    document.addEventListener('pagehide', onPageHide);

    return () => {
      let temp_banner_report = [];

      setTimeout(() => {
        console.log('returned--------------');
        temp_banner_report = sessionStorage.getItem('banner_report');
        if (temp_banner_report && temp_banner_report?.length > 0) {
          dispatch(
            addBannerReport(temp_banner_report, (response) => {
              dispatch(clearBannerReport());
              sessionStorage.removeItem('banner_report');
            })
          );
        }
      }, 200);

      document.removeEventListener(visibilityChange, sendReportData);
      document.removeEventListener('pagehide', onPageHide);

      // dispatch(updateBannerShowStatus());
      // dispatch(updateBannerfetchStatus(0));
      // dispatch(updateBannerCardIndex(0));
      // dispatch(clearContentBannerData());
      // dispatch(clearGlobalBannerData());
      // dispatch(content_data_get_pending());
      // dispatch(cleanCurrentQueue());

      // setSessionStorage(
      //   bannerLocalConstant.PLAYED_CATEGORY,
      //   JSON.stringify(innitial_current_queue)
      // );

      // global_session_store_data = '';
      // global_local_store_data = '';
    };
  }, []);

  useEffect(() => {
    // alert('hii');
    dispatch(updateBannerShowStatus());
    setSessionStorage(bannerLocalConstant.PLAYED_CATEGORY, JSON.stringify(innitial_current_queue));
    let global_session_store_data = sessionStorage.getItem(bannerLocalConstant.GLOBAL_BANNER_DATA);
    let global_local_store_data = bannerUtils.getDataFromLocalStorage(
      bannerLocalConstant.GLOBAL_BANNER_DATA
    );

    if (global_session_store_data) {
      global_session_store_data = JSON.parse(global_session_store_data);
      checkDataValidity(
        global_session_store_data.last_fetch_timestamp,
        global_session_store_data.expire_timestamp,
        global_session_store_data
      );
    } else if (global_local_store_data) {
      global_local_store_data = JSON.parse(global_local_store_data);
      checkDataValidity(
        global_local_store_data.last_fetch_timestamp,
        global_local_store_data.expire_timestamp,
        global_local_store_data
      );
    } else {
      dispatch(
        getBannerSetting((response) => {
          dispatch(
            getPlatformBanner((_response) => {
              syncBannerData(_response);
            })
          );
        })
      );
    }

    if (url_id && url_id != 0) {
      dispatch(getExclutionList());
      dispatch(
        getBannerDataById(type, url_id, (res) => {
          let tempUpdatedStatus = 0;
          tempUpdatedStatus = banner_fetch_status_ref.current + 1;
          console.log('get by id', tempUpdatedStatus, banner_fetch_status_ref.current);
          setTimeout(() => {
            dispatch(updateBannerfetchStatus(tempUpdatedStatus));
            dispatch(content_data_get_done());
          }, 500);
        })
      );
    }
    return () => {
      dispatch(updateBannerShowStatus());
      dispatch(updateBannerfetchStatus(0));
      dispatch(updateBannerCardIndex(0));
      dispatch(clearContentBannerData());
      dispatch(clearGlobalBannerData());
      dispatch(content_data_get_pending());
      dispatch(cleanCurrentQueue());

      setSessionStorage(
        bannerLocalConstant.PLAYED_CATEGORY,
        JSON.stringify(innitial_current_queue)
      );
    };
  }, [url_id]);

  function onPageHide() {
    let temp_banner_report = [];
    temp_banner_report = sessionStorage.getItem('banner_report');
    temp_banner_report = temp_banner_report ? JSON.parse(temp_banner_report) : '';

    if (temp_banner_report && temp_banner_report?.length > 0) {
      let reporting_array_temp = {};
      reporting_array_temp.data = temp_banner_report;
      reporting_array_temp.version = appVersion;
      reporting_array_temp.os = platform_name;
      reporting_array_temp.token = getLocalStorage('accessToken', '');

      let _data = JSON.stringify(reporting_array_temp);
      navigator.sendBeacon(`${api_url}/openapi/clirbannerBeacone`, _data);
    }
  }

  const sendReportData = () => {
    let dispachTimeout = '';
    if (document.visibilityState == 'hidden') {
      let temp_banner_report = [];
      temp_banner_report = sessionStorage.getItem('banner_report');
      temp_banner_report = temp_banner_report ? JSON.parse(temp_banner_report) : '';
      console.log('visibility hidden called ');

      if (temp_banner_report?.length > 0) {
        // dispachTimeout = setTimeout(() => {
        console.log('report send----------');
        // if (temp_banner_report && temp_banner_report?.length > 0) {
        dispatch(
          addBannerReport(temp_banner_report, (response) => {
            sessionStorage.setItem('banner_report', []);
            dispatch(clearBannerReport());
          })
        );
        // }
        // }, 500);
      }
    } else {
      // if (dispachTimeout) {
      //     clearTimeout(dispachTimeout);
      // }
    }
  };

  useEffect(() => {
    banner_settings?.length > 0 && syncBannerSetting();
  }, [banner_settings]);

  const syncWithSessionStorage = () => {
    let global_session_store_data = sessionStorage.getItem(bannerLocalConstant.GLOBAL_BANNER_DATA);
    let global_local_store_data = bannerUtils.getDataFromLocalStorage(
      bannerLocalConstant.GLOBAL_BANNER_DATA
    );

    if (global_local_store_data && !global_session_store_data) {
      sessionStorage.setItem(bannerLocalConstant.GLOBAL_BANNER_DATA, global_local_store_data);
    }
  };

  const syncBannerSetting = () => {
    bannerUtils.setDataOnLocalStorage(
      bannerLocalConstant.GLOBAL_BANNER_SETTING_DATA,
      JSON.stringify(banner_settings)
    );
  };

  // additional props effect
  function syncBannerData(data) {
    console.log('sync....................');
    local_store_banner_data.global_banner_data =
      data?.data?.length > 0 && getFormatedBannerData(data.data);
    local_store_banner_data.get_timestamp = data.timestamp_added ? data.timestamp_added : '0';
    local_store_banner_data.last_fetch_timestamp = bannerUtils.getCurrentTime();

    const tempCurrentTime = dayjs(new Date()).add(
      BANNER_DATA_FETCH_INTERVAL,
      BANNER_DATA_FETCH_PERIOD
    );
    const newExpTime = dayjs(tempCurrentTime).format(BANNER_DATE_FORMAT);
    local_store_banner_data.expire_timestamp = newExpTime;

    sessionStorage.setItem(
      bannerLocalConstant.GLOBAL_BANNER_DATA,
      JSON.stringify(local_store_banner_data)
    );
    bannerUtils.setDataOnLocalStorage(
      bannerLocalConstant.GLOBAL_BANNER_DATA,
      JSON.stringify(local_store_banner_data)
    );
    // alert('syncBannerData' + banner_fetch_status_ref.current);
    let updatedStatus = 0;
    updatedStatus = banner_fetch_status_ref.current + 1;
    dispatch(updateBannerfetchStatus(updatedStatus));
  }

  const getFormatedBannerData = (params_data = []) => {
    let arg_data = params_data;

    if (arg_data?.length > 0) {
      const temp_local_banner_data = {
        top_banner_data: bannerUtils.filterJsonByPosition(
          arg_data,
          bannerLocalConstant.BANNER_POSITION_TOP
        ),
        side_top_banner_data: bannerUtils.filterJsonByPosition(
          arg_data,
          bannerLocalConstant.BANNER_POSITION_SIDE_TOP
        ),
        bottom_banner_data: bannerUtils.filterJsonByPosition(
          arg_data,
          bannerLocalConstant.BANNER_POSITION_BOTTOM
        ),
        side_bottom_banner_data: bannerUtils.filterJsonByPosition(
          arg_data,
          bannerLocalConstant.BANNER_POSITION_SIDE_BOTTOM
        ),
        list_banner_data: bannerUtils.filterJsonByPosition(
          arg_data,
          bannerLocalConstant.BANNER_POSITION_LIST
        ),
        section_header_banner_data: bannerUtils.filterJsonByPosition(
          arg_data,
          bannerLocalConstant.BANNER_POSITION_SECTION_HEADER
        ),
        video_banner_data: bannerUtils.filterJsonByPosition(
          arg_data,
          bannerLocalConstant.BANNER_POSITION_VIDEO
        ),
        video_floating_banner_data: bannerUtils.filterJsonByPosition(
          arg_data,
          bannerLocalConstant.BANNER_POSITION_IN_VIDEO_FLOATING
        ),
        interstitial_banner_data: bannerUtils.filterJsonByPosition(
          arg_data,
          bannerLocalConstant.BANNER_POSITION_INTERSTITIAL
        )
      };
      return temp_local_banner_data;
    } else {
      return [];
    }
  };

  const checkDataValidity = (startTime = '', endTime = '', data = '') => {
    let local_store_data_ = data;

    // alert(`::is valid checking::${dayjs(startTime, BANNER_DATE_FORMAT, true).isValid()}`);
    if (
      !dayjs(startTime, BANNER_DATE_FORMAT, true).isValid() ||
      !dayjs(endTime, BANNER_DATE_FORMAT, true).isValid()
    ) {
      bannerUtils.log('invalid date get from local');
      dispatch(
        getBannerSetting((response) => {
          dispatch(getPlatformBanner((_response) => syncBannerData(_response)));
        })
      );
      //dispatch(getExclutionList())

      return false;
    }

    let startTimeDif = bannerUtils.getTimeDifference(startTime);
    let endTimeDif = bannerUtils.getTimeDifference(endTime);
    startTimeDif = Math.round(startTimeDif);
    endTimeDif = Math.round(endTimeDif);

    let exclution_list__local_store_data = bannerUtils.getDataFromLocalStorage(
      bannerLocalConstant.GLOBAL_EXCLUTION_LIST_DATA
    )
      ? JSON.parse(
          bannerUtils.getDataFromLocalStorage(bannerLocalConstant.GLOBAL_EXCLUTION_LIST_DATA)
        )
      : [];

    let banner_settings_local_store_data = bannerUtils.getDataFromLocalStorage(
      bannerLocalConstant.GLOBAL_BANNER_SETTING_DATA
    )
      ? JSON.parse(
          bannerUtils.getDataFromLocalStorage(bannerLocalConstant.GLOBAL_BANNER_SETTING_DATA)
        )
      : [];

    bannerUtils.log(startTimeDif + '::' + endTimeDif);
    let myCounter;
    if (startTimeDif >= 0 && endTimeDif <= 0) {
      //need to replace with  isBetween from dayjs
      bannerUtils.log('data is vaild');

      if (
        !local_store_data_.global_banner_data.top_banner_data ||
        !local_store_data_.global_banner_data.side_top_banner_data ||
        !local_store_data_.global_banner_data.bottom_banner_data ||
        !local_store_data_.global_banner_data.side_bottom_banner_data ||
        !local_store_data_.global_banner_data.list_banner_data ||
        !local_store_data_.global_banner_data.section_header_banner_data ||
        !local_store_data_.global_banner_data.video_banner_data ||
        !local_store_data_.global_banner_data.video_floating_banner_data
      ) {
        dispatch(
          getBannerSetting((response) => {
            dispatch(
              getPlatformBanner((_response) => {
                syncBannerData(_response);
              })
            );
          })
        );
        //dispatch(getExclutionList())
      } else {
        dispatch(syncBannerSettingsWithReduxStore(banner_settings_local_store_data));
        // dispatch(syncExclutionListWithReduxStore(exclution_list__local_store_data));
        dispatch(syncLocalDataWithReduxStore(local_store_data_.global_banner_data));
        let tempStatus = 0;
        // console.log('tempStat', tempStatus, banner_fetch_status_ref.current);
        // tempStatus = banner_fetch_status + 1;
        // alert(`hihi${tempStatus}::${banner_fetch_status_ref.current}`);
        dispatch(updateBannerfetchStatus(1));
      }
    } else {
      dispatch(
        getBannerSetting((response) => {
          dispatch(
            getPlatformBanner((_response) => {
              syncBannerData(_response);
            })
          );
        })
      );
      //dispatch(getExclutionList())
    }

    if (endTimeDif && endTimeDif < 0) {
      myCounter = new Countdown({
        seconds: Math.abs(Math.ceil(endTimeDif)),
        onCounterEnd: function () {
          dispatch(
            getBannerSetting((res) => {
              dispatch(
                getPlatformBanner((_response) => {
                  syncBannerData(_response);
                })
              );
            })
          );
          //dispatch(getExclutionList());
        }
      });
      myCounter.start();
    }
    //console.groupEnd("checking validity")
  };

  return (
    <>
      {url_id && url_id != 0 && <InterstitialAds page_name={page_name} position="interstitial" />}
    </>
  );
}

BannerWorker.propTypes = {
  page_name: PropTypes.string.isRequired
};
export default BannerWorker;
